<template>
    <el-dialog class="dialog" :visible="dialogs.hardSkills" customClass="dialog_main" :append-to-body="true" :close-on-click-modal="false" @close="closeDialog()" @open="handleOpen">
        <div slot="title" class="dialog__head dialog__head_second">
            <div class="dialog__head-inner">
                <h3 class="dialog__title">Hard Skills</h3>
            </div>
        </div>

        <div slot="default" class="dialog__inner">
            <div class="dialog__content">
                <form class="search-form" @submit.prevent>
                    <div class="search-form__inner">
                        <input type="search" class="input search-form__input" :class="{ 'search-form__input_reset': input && input.length !== 0 }" placeholder="Поиск" v-model.trim="input" @keydown.enter.prevent.stop>

                        <button v-if="input && input.length !== 0" class="search-form__reset" @click="input = ''">
                            <icon-base viewBox="0 0 14 14"><icon-cancel /></icon-base>
                        </button>

                        <button class="search-form__submit">
                            <icon-base viewBox="0 0 24 24"><icon-search /></icon-base>
                        </button>
                    </div>
                </form>

                <transition name="fade">
                    <div class="dialog__section" v-if="createEntity">
                        <h3>Заполните новый Hard Skill</h3>

                        <form class="entity-form" @submit.prevent="createItem">
                            <div class="entity-form__inner">
                                <div class="entity-form__item">
                                    <el-checkbox v-model="checkedEntity" />
                                </div>
                                <div class="entity-form__item entity-form__item_name">
                                    <validate-input v-model="newHardSkillName" v-bind:error="newHardSkillNameError" v-on:update:error="newHardSkillNameError = $event" type="text" name="name" placeholder="Название" :validateOptions="['empty']" />
                                </div>
                                <div class="entity-form__item">
                                    <button type="submit" class="btn btn_action" :disabled="!newHardSkillName">Создать</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </transition>

                <el-table
                    cell-class-name="table__cell"
                    class="table table_second"
                    header-cell-class-name="table__title"
                    :max-height="createEntity ? 250 : 300"
                    ref="table"
                    row-key="id"
                    :data="filteredData"
                    :default-sort="{ prop: 'code', order: 'ascending' }"
                    @sort-change="sortChange"
                >
                    <el-table-column
                            width="24"
                    >
                        <template slot-scope="scope">
                            <div class="table_flex">
                                <el-checkbox @change="handleSelectionChange([scope.row])"/>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="Название"
                        prop="name"
                        sortable
                        :min-width="90"
                        :sort-orders="['ascending', 'descending']"
                    >
                    </el-table-column>
                </el-table>

                <h3 class="dialog__title mt-32 mb-16">Выбранные сущности</h3>

                <el-table
                    cell-class-name="table__cell"
                    class="table table_second"
                    header-cell-class-name="table__title"
                    :max-height="createEntity ? 250 : 300"
                    row-key="id"
                    :show-header="false"
                    :data="selection"
                    :default-sort="{ prop: 'code', order: 'ascending' }"
                >
                    <el-table-column
                        width="24"
                    >
                        <template slot-scope="scope">
                            <div class="table_flex">
                                <el-checkbox checked @change="deleteSelectionChange([scope.row])"/>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="Название"
                        prop="name"
                        sortable
                        :min-width="90"
                        :sort-orders="['ascending', 'descending']"
                    >
                    </el-table-column>
                </el-table>
            </div>

            <footer slot="footer" class="dialog__footer mt-24">
                <div class="dialog__footer-inner">
                    <div class="dialog__footer-item">
                        <button type="button" class="btn" @click="closeDialog">Отменить</button>
                    </div>
                    <div class="dialog__footer-item">
                        <button type="submit" class="btn btn_action-second" :disabled="createEntity" @click="createEntity = true">
                            Создать новый Hard Skill

                            <icon-base width="12" height="12" viewBox="0 0 12 12" class="btn__icon"><icon-action /></icon-base>
                        </button>
                        <button type="submit" class="btn btn_action" :disabled="selection.length === 0" @click="submitSelected">Добавить выбранные Hard Skills</button>
                    </div>
                </div>
            </footer>
        </div>
    </el-dialog>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';

import dialog from '@/mixins/dialog';
import ValidateInput from '@/components/ValidateInput'

import { mergeArrsByKey } from '@/helpers';

export default {
    mixins: [ dialog ],
    props: {
        qualificationId: {
            required: true,
            type: Number
        }
    },
    components: {
        ValidateInput
    },
    data() {
        return {
            checkedEntity: true,
            newHardSkillName: '',
            newHardSkillNameError: false,
        }
    },
    methods: {
        ...mapActions('editor', [
            'LOAD_HARD_SKILLS',
            'LOAD_HARD_SKILLS_BY_QUALIFICATION',
            'CREATE_HARD_SKILL',
            'UPDATE_HARD_SKILLS',
            'UPDATE_HARD_SKILLS_BY_QUALIFICATION',
        ]),
        ...mapMutations('editor', ['SET_QUALIFICATIONS', 'GROUP_QUALIFICATIONS']),

        closeDialog() {
            this.newHardSkillName = ''
            this.newHardSkillNameError = false
            this.createEntity = false

            this.selection = []

            this.elDialogs.hardSkills = false;
        },
        createItem(e) {
            // Собираем новые значения и отправляем
            const formData = new FormData(e.target);

            const params = {};

            for (const pair of formData.entries()) {
                params[pair[0]] = pair[1];
            }

            this.CREATE_HARD_SKILL(params).then((hardSkill) => {
                e.target.reset();

                this.data = [...this.hardSkills];

                if (this.checkedEntity) {
                    this.selection.push(hardSkill);
                }
            });
        },
        handleSelectionChange(val) {
            this.selection = [...val, ...this.selection];
        },
        deleteSelectionChange(val) {
            this.selection = this.selection.filter(select => !val.find(item => item.id === select.id))
        },
        async handleOpen() {
            await this.LOAD_HARD_SKILLS();

            const ids = this.hardSkillsByQualification.map(el => el.id)

            this.data = [...this.hardSkills].filter(el => !ids.includes(el.id));
        },
        sortChange(v) {
            if (v.column.order === 'ascending') {
                this.data.sort(this.sortListAsc(v.column.property));
            } else if (v.column.order === 'descending') {
                this.data.sort(this.sortListDesc(v.column.property));
            }
        },
        async submitSelected() {
            const ids = [...new Set(this.selection.map((item) => item.id), ...this.hardSkillsByQualification.map((item) => item.id))];

            await this.UPDATE_HARD_SKILLS_BY_QUALIFICATION({
                id: this.qualificationId,
                ids
            });
            await this.LOAD_HARD_SKILLS_BY_QUALIFICATION(this.qualificationId)

            const tempQualifications = JSON.parse(JSON.stringify(this.qualifications))
            await this.SET_QUALIFICATIONS(tempQualifications.map(qualification => qualification.id === this.qualificationId ? Object.assign(qualification, { hard_skills: this.hardSkillsByQualification.length }) : qualification))
            this.GROUP_QUALIFICATIONS(this.groupItemsBy.name);

            this.closeDialog();
        }
    },
    computed: {
        ...mapState('editor', ['hardSkills', 'hardSkillsByQualification', 'qualifications', 'groupItemsBy']),
        
        searchedData() {
            return this.input ? this.data.filter(el => el.name.toLowerCase().includes(this.input.toLowerCase())) : this.data
        },
        filteredData() {
            return this.searchedData.filter(el => !this.selection.find(select => select.id === el.id))
        }
    }
}
</script>
